import * as React from "react";
import { toRelativeUrl } from "@okta/okta-auth-js";
import { useOktaAuth } from "@okta/okta-react";
import { useEffect } from "react";
import {LoadingSpinner} from "../icons/LoadingSpinner.component";
import { Outlet } from "react-router-dom";
import {triggerOktaLogin} from "../../utils/oktaUtil";

export const RequiredAuth: React.FunctionComponent = () => {
    const { oktaAuth, authState } = useOktaAuth();

    useEffect(() => {
        if (!authState) {
            return;
        }

        if (!authState?.isAuthenticated) {
            const originalUri = toRelativeUrl(window.location.href, window.location.origin);
            triggerOktaLogin(originalUri);
        }
    }, [oktaAuth, !!authState, authState?.isAuthenticated]);

    if (!authState || !authState?.isAuthenticated) {
        return (<LoadingSpinner/>);
    }

    return (<Outlet/>);
};